// TIBECO - Echipamente Producție - Gestionarea utilajelor și echipamentelor pentru producția de ferestre și uși
import React, { useState } from 'react';
import { 
  Settings, Search, AlertTriangle, TrendingUp, Plus, Wrench,
  Calendar, Clock, CheckCircle, XCircle, Activity, Users,
  Zap, Shield, BarChart3, FileText, Download, Edit,
  MapPin, Tool, AlertCircle
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const EquipmentManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('toate');
  const [isMaintenanceModalOpen, setIsMaintenanceModalOpen] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [isAddEquipmentModalOpen, setIsAddEquipmentModalOpen] = useState(false);

  // Mock data specific TIBECO - echipamente reale pentru producția de ferestre și uși
  const mockEquipment = [
    {
      id: 1,
      name: 'Mașină Sudură Profile PVC Model WS-2500',
      type: 'Echipament Sudură',
      model: 'WS-2500 Professional',
      serialNumber: 'TBC-WS-001',
      manufacturer: 'WEGOMA',
      status: 'operațional',
      location: 'Atelier Principal',
      operator: 'Ion Popescu',
      operatingHours: 8420,
      maxOperatingHours: 15000,
      lastMaintenance: '2024-03-01',
      nextMaintenance: '2024-04-15',
      yearPurchased: 2021,
      purchasePrice: '45,000 RON',
      productivity: '85%',
      efficiency: '92%',
      maintenanceCost: '2,100 RON',
      workOrders: 156,
      downtime: '2.3 ore',
      energyConsumption: '12.5 kWh'
    },
    {
      id: 2,
      name: 'Centru Prelucrare CNC pentru Aluminiu',
      type: 'Mașină CNC',
      model: 'AL-CNC-4000',
      serialNumber: 'TBC-CNC-002',
      manufacturer: 'ELUMATEC',
      status: 'operațional',
      location: 'Secția Aluminiu',
      operator: 'Maria Ionescu',
      operatingHours: 6750,
      maxOperatingHours: 20000,
      lastMaintenance: '2024-03-10',
      nextMaintenance: '2024-05-01',
      yearPurchased: 2022,
      purchasePrice: '125,000 RON',
      productivity: '94%',
      efficiency: '96%',
      maintenanceCost: '3,500 RON',
      workOrders: 98,
      downtime: '1.1 ore',
      energyConsumption: '18.2 kWh'
    },
    {
      id: 3,
      name: 'Ferăstrău Circular Automatizat',
      type: 'Ferăstrău',
      model: 'SC-AUTO-3000',
      serialNumber: 'TBC-SAW-003',
      manufacturer: 'STRIEBIG',
      status: 'în mentenanță',
      location: 'Atelier Debitare',
      operator: 'Andrei Munteanu',
      operatingHours: 12500,
      maxOperatingHours: 15000,
      lastMaintenance: '2024-03-20',
      nextMaintenance: '2024-03-25',
      yearPurchased: 2019,
      purchasePrice: '32,000 RON',
      productivity: '78%',
      efficiency: '85%',
      maintenanceCost: '1,800 RON',
      workOrders: 203,
      downtime: '8.5 ore',
      energyConsumption: '8.7 kWh'
    },
    {
      id: 4,
      name: 'Sistem Automot Transportor',
      type: 'Transport Automatizat',
      model: 'CONV-5000',
      serialNumber: 'TBC-CONV-004',
      manufacturer: 'HOMAG',
      status: 'operațional',
      location: 'Linia de Producție',
      operator: 'Gheorghe Dinu',
      operatingHours: 9200,
      maxOperatingHours: 25000,
      lastMaintenance: '2024-02-28',
      nextMaintenance: '2024-04-30',
      yearPurchased: 2020,
      purchasePrice: '85,000 RON',
      productivity: '89%',
      efficiency: '91%',
      maintenanceCost: '2,800 RON',
      workOrders: 112,
      downtime: '3.2 ore',
      energyConsumption: '15.4 kWh'
    },
    {
      id: 5,
      name: 'Mașină Montaj Hardware și Feronerie',
      type: 'Montaj Automatizat',
      model: 'HW-MOUNT-2000',
      serialNumber: 'TBC-HW-005',
      manufacturer: 'MACO Systems',
      status: 'defect',
      location: 'Secția Finalizare',
      operator: 'Elena Cristea',
      operatingHours: 5800,
      maxOperatingHours: 12000,
      lastMaintenance: '2024-03-18',
      nextMaintenance: '2024-03-30',
      yearPurchased: 2023,
      purchasePrice: '67,500 RON',
      productivity: '72%',
      efficiency: '80%',
      maintenanceCost: '4,200 RON',
      workOrders: 45,
      downtime: '15.8 ore',
      energyConsumption: '9.3 kWh'
    },
    {
      id: 6,
      name: 'Cuptor Uscare și Tratament Termic',
      type: 'Cuptor Industrial',
      model: 'OVEN-TEMP-3500',
      serialNumber: 'TBC-OVEN-006',
      manufacturer: 'REHAU Industrial',
      status: 'operațional',
      location: 'Secția Tratamente',
      operator: 'Vasile Gheorghiu',
      operatingHours: 7650,
      maxOperatingHours: 18000,
      lastMaintenance: '2024-03-15',
      nextMaintenance: '2024-05-15',
      yearPurchased: 2021,
      purchasePrice: '95,000 RON',
      productivity: '91%',
      efficiency: '94%',
      maintenanceCost: '3,100 RON',
      workOrders: 78,
      downtime: '1.9 ore',
      energyConsumption: '22.8 kWh'
    }
  ];

  // Filtrare echipamente
  const filteredEquipment = mockEquipment.filter(equipment => {
    const matchesSearch = equipment.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         equipment.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         equipment.operator.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterStatus === 'toate' || equipment.status === filterStatus;
    
    return matchesSearch && matchesFilter;
  });

  // Statistici KPI
  const totalEquipment = mockEquipment.length;
  const operationalEquipment = mockEquipment.filter(eq => eq.status === 'operațional').length;
  const averageEfficiency = Math.round(
    mockEquipment.reduce((acc, eq) => {
      if (!eq.efficiency) return acc;
      const efficiency = typeof eq.efficiency === 'string' 
        ? parseFloat(eq.efficiency.replace('%', '')) 
        : parseFloat(eq.efficiency.toString());
      return acc + (efficiency || 0);
    }, 0) / totalEquipment
  );
  const totalMaintenanceCost = mockEquipment.reduce((acc, eq) => {
    if (!eq.maintenanceCost) return acc;
    const cost = typeof eq.maintenanceCost === 'string' 
      ? parseFloat(eq.maintenanceCost.replace(/[^\d]/g, '')) 
      : parseFloat(eq.maintenanceCost.toString().replace(/[^\d]/g, ''));
    return acc + (cost || 0);
  }, 0);

  const columns = [
    { 
      key: 'name', 
      label: 'Echipament', 
      render: (equipment) => (
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-primary-100 dark:bg-primary-900/50 rounded-lg">
            <Settings className="w-5 h-5 text-primary-600" />
          </div>
          <div>
            <div className="font-medium text-gray-900 dark:text-white">{equipment.name}</div>
            <div className="text-sm text-gray-500">{equipment.model} • {equipment.serialNumber}</div>
          </div>
        </div>
      )
    },
    { 
      key: 'status', 
      label: 'Status', 
      render: (equipment) => (
        <Badge 
          variant={
            equipment.status === 'operațional' ? 'success' : 
            equipment.status === 'în mentenanță' ? 'warning' : 'error'
          }
        >
          {equipment.status === 'operațional' && <CheckCircle className="w-3 h-3 mr-1" />}
          {equipment.status === 'în mentenanță' && <Clock className="w-3 h-3 mr-1" />}
          {equipment.status === 'defect' && <XCircle className="w-3 h-3 mr-1" />}
          {equipment.status ? equipment.status.charAt(0).toUpperCase() + equipment.status.slice(1) : 'Necunoscut'}
        </Badge>
      )
    },
    { 
      key: 'operator', 
      label: 'Operator', 
      render: (equipment) => (
        <div className="flex items-center space-x-2">
          <div className="flex items-center justify-center w-8 h-8 bg-gray-200 dark:bg-gray-700 rounded-full">
            <Users className="w-4 h-4 text-gray-600" />
          </div>
          <span className="text-sm font-medium">{equipment.operator}</span>
        </div>
      )
    },
    { 
      key: 'efficiency', 
      label: 'Eficiență', 
      render: (equipment) => {
        const efficiency = equipment.efficiency ? equipment.efficiency.toString() : '0%';
        const numValue = parseFloat(efficiency.replace('%', '')) || 0;
        return (
          <div className="flex items-center space-x-2">
            <div className={`w-2 h-2 rounded-full ${
              numValue >= 90 ? 'bg-green-500' :
              numValue >= 80 ? 'bg-yellow-500' : 'bg-red-500'
            }`}></div>
            <span className="font-medium">{efficiency}</span>
          </div>
        );
      }
    },
    { 
      key: 'location', 
      label: 'Locație', 
      render: (equipment) => (
        <div className="flex items-center space-x-2">
          <MapPin className="w-4 h-4 text-gray-400" />
          <span className="text-sm">{equipment.location}</span>
        </div>
      )
    },
    { 
      key: 'nextMaintenance', 
      label: 'Următoarea Mentenanță', 
      render: (equipment) => {
        const isOverdue = new Date(equipment.nextMaintenance) < new Date();
        return (
          <div className={`flex items-center space-x-2 ${isOverdue ? 'text-red-600' : 'text-gray-600'}`}>
            <Calendar className="w-4 h-4" />
            <span className="text-sm">{equipment.nextMaintenance}</span>
            {isOverdue && <AlertTriangle className="w-4 h-4 text-red-500" />}
          </div>
        );
      }
    }
  ];

  const handleMaintenanceSchedule = (equipment) => {
    setSelectedEquipment(equipment);
    setIsMaintenanceModalOpen(true);
  };

  return (
    <div className="space-y-6">
      {/* Header cu acțiuni */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Echipamente Producție</h1>
          <p className="text-gray-600 dark:text-gray-400">Gestionarea echipamentelor și utilajelor TIBECO</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => setIsAddEquipmentModalOpen(true)}
            className="btn-primary flex items-center space-x-2"
          >
            <Plus className="w-4 h-4" />
            <span>Adaugă Echipament</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <Download className="w-4 h-4" />
            <span>Export Raport</span>
          </button>
        </div>
      </div>

      {/* KPI-uri (4 cards cu statistici) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card variant="stats" className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100">Total Echipamente</p>
              <p className="text-3xl font-bold">{totalEquipment}</p>
            </div>
            <Settings className="w-8 h-8 text-blue-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-green-500 to-green-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100">Operaționale</p>
              <p className="text-3xl font-bold">{operationalEquipment}/{totalEquipment}</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-purple-500 to-purple-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100">Eficiență Medie</p>
              <p className="text-3xl font-bold">{averageEfficiency}%</p>
            </div>
            <BarChart3 className="w-8 h-8 text-purple-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-orange-500 to-orange-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-orange-100">Costuri Mentenanță</p>
              <p className="text-3xl font-bold">{(totalMaintenanceCost / 1000).toFixed(0)}K</p>
            </div>
            <Wrench className="w-8 h-8 text-orange-200" />
          </div>
        </Card>
      </div>

      {/* Filtre și căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Căutare echipamente, modele, operatori..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input pl-10 w-full"
              />
            </div>
          </div>
          
          <div className="sm:w-48">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="input w-full"
            >
              <option value="toate">Toate Statusurile</option>
              <option value="operațional">Operațional</option>
              <option value="în mentenanță">În Mentenanță</option>
              <option value="defect">Defect</option>
            </select>
          </div>
        </div>
      </Card>

      {/* Tabel echipamente */}
      <Card>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            Lista Echipamente ({filteredEquipment.length})
          </h2>
        </div>
        
        <Table 
          data={filteredEquipment}
          columns={columns}
          onRowClick={handleMaintenanceSchedule}
        />
      </Card>

      {/* Modal Detalii Mentenanță Echipament */}
      <Modal
        isOpen={isMaintenanceModalOpen}
        onClose={() => setIsMaintenanceModalOpen(false)}
        title={selectedEquipment ? `${selectedEquipment.name}` : ''}
        size="xl"
      >
        {selectedEquipment && (
          <div className="space-y-6">
            {/* Info generală */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Model & Serie</label>
                  <p className="text-lg font-semibold">{selectedEquipment.model}</p>
                  <p className="text-sm text-gray-600">{selectedEquipment.serialNumber}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Producător</label>
                  <p className="text-lg">{selectedEquipment.manufacturer}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Operator Responsabil</label>
                  <p className="text-lg">{selectedEquipment.operator}</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Status Current</label>
                  <div className="mt-1">
                    <Badge 
                      variant={
                        selectedEquipment.status === 'operațional' ? 'success' : 
                        selectedEquipment.status === 'în mentenanță' ? 'warning' : 'error'
                      }
                    >
                      {selectedEquipment.status.charAt(0).toUpperCase() + selectedEquipment.status.slice(1)}
                    </Badge>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Eficiență</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-3">
                      <div 
                        className="bg-gradient-to-r from-green-400 to-green-600 h-3 rounded-full"
                        style={{ width: selectedEquipment.efficiency }}
                      ></div>
                    </div>
                    <span className="text-lg font-semibold">{selectedEquipment.efficiency}</span>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Următoarea Mentenanță</label>
                  <p className="text-lg font-semibold text-primary-600">{selectedEquipment.nextMaintenance}</p>
                </div>
              </div>
            </div>

            {/* Statistici operaționale */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Statistici Operaționale</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Clock className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Ore Funcționare</span>
                  </div>
                  <p className="text-xl font-bold">{selectedEquipment.operatingHours.toLocaleString()}</p>
                  <p className="text-sm text-gray-600">din {selectedEquipment.maxOperatingHours.toLocaleString()}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Activity className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Productivitate</span>
                  </div>
                  <p className="text-xl font-bold">{selectedEquipment.productivity}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Zap className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Consum Energie</span>
                  </div>
                  <p className="text-xl font-bold">{selectedEquipment.energyConsumption}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <AlertCircle className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Downtime</span>
                  </div>
                  <p className="text-xl font-bold text-red-600">{selectedEquipment.downtime}</p>
                </div>
              </div>
            </div>

            {/* Acțiuni */}
            <div className="border-t pt-6">
              <div className="flex flex-wrap gap-3">
                <button className="btn-primary flex items-center space-x-2">
                  <Calendar className="w-4 h-4" />
                  <span>Programează Mentenanță</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Edit className="w-4 h-4" />
                  <span>Editează Detalii</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <FileText className="w-4 h-4" />
                  <span>Istoric Mentenanță</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <BarChart3 className="w-4 h-4" />
                  <span>Raport Performanță</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Adaugă Echipament */}
      <Modal
        isOpen={isAddEquipmentModalOpen}
        onClose={() => setIsAddEquipmentModalOpen(false)}
        title="Adaugă Echipament Nou"
        size="lg"
      >
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="label">Nume Echipament</label>
              <input type="text" className="input" placeholder="ex: Mașină Sudură Profile PVC" />
            </div>
            <div>
              <label className="label">Tip Echipament</label>
              <select className="input">
                <option>Selectează tipul...</option>
                <option>Echipament Sudură</option>
                <option>Mașină CNC</option>
                <option>Ferăstrău</option>
                <option>Transport Automatizat</option>
                <option>Montaj Automatizat</option>
                <option>Cuptor Industrial</option>
              </select>
            </div>
            <div>
              <label className="label">Model</label>
              <input type="text" className="input" placeholder="ex: WS-2500 Professional" />
            </div>
            <div>
              <label className="label">Număr de Serie</label>
              <input type="text" className="input" placeholder="ex: TBC-WS-007" />
            </div>
            <div>
              <label className="label">Producător</label>
              <input type="text" className="input" placeholder="ex: WEGOMA" />
            </div>
            <div>
              <label className="label">Locație</label>
              <select className="input">
                <option>Selectează locația...</option>
                <option>Atelier Principal</option>
                <option>Secția Aluminiu</option>
                <option>Atelier Debitare</option>
                <option>Linia de Producție</option>
                <option>Secția Finalizare</option>
                <option>Secția Tratamente</option>
              </select>
            </div>
            <div>
              <label className="label">Operator Responsabil</label>
              <select className="input">
                <option>Selectează operatorul...</option>
                <option>Ion Popescu</option>
                <option>Maria Ionescu</option>
                <option>Andrei Munteanu</option>
                <option>Gheorghe Dinu</option>
                <option>Elena Cristea</option>
                <option>Vasile Gheorghiu</option>
              </select>
            </div>
            <div>
              <label className="label">Preț Achiziție (RON)</label>
              <input type="number" className="input" placeholder="ex: 45000" />
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 border-t pt-4">
            <button 
              onClick={() => setIsAddEquipmentModalOpen(false)}
              className="btn-secondary"
            >
              Anulează
            </button>
            <button className="btn-primary">
              Adaugă Echipament
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EquipmentManagement;